<!-- 登录页 -->
<template>
  <div class="login-page" ref="slider">
    <!-- 右上角标 -->
    <div class="login-btn index-u-item">
      <div class="login-btn-box" v-show="currentPage!==1" @click="currentPage = 1"><span>登录</span></div>
      <div class="login-btn-box" v-show="currentPage===1" @click="currentPage = 2"><span>产品简介</span></div>
    </div>
    <!-- 下拉 -->
    <img class="down cursor-pointer" v-show="currentPage!==5" @click="goPage(null)" @mouseover="downImg=downActive" @mouseout="downImg=down" :src="downImg"/>
    <!-- 右侧页码 -->
    <div class="page-index">
      <ul>
        <li class="page-index-c cursor-pointer" @click="goPage(1)" :class="{'page-index-current': 1 === currentPage, 'page-index-hover': (1 === indexHover) && (currentPage !== 1)}" @mouseover="indexHover = 1" @mouseout="indexHover = -1"></li>
        <li class="page-index-c cursor-pointer" @click="goPage(2)" :class="{'page-index-current': 2 === currentPage, 'page-index-hover': (2 === indexHover) && (currentPage !== 2)}" @mouseover="indexHover = 2" @mouseout="indexHover = -1"></li>
        <li class="page-index-c cursor-pointer" @click="goPage(3)" :class="{'page-index-current': 3 === currentPage, 'page-index-hover': (3 === indexHover) && (currentPage !== 3)}" @mouseover="indexHover = 3" @mouseout="indexHover = -1"></li>
        <li class="page-index-c cursor-pointer" @click="goPage(4)" :class="{'page-index-current': 4 === currentPage, 'page-index-hover': (4 === indexHover) && (currentPage !== 4)}" @mouseover="indexHover = 4" @mouseout="indexHover = -1"></li>
        <li class="page-index-c cursor-pointer" @click="goPage(5)" :class="{'page-index-current': 5 === currentPage, 'page-index-hover': (5 === indexHover) && (currentPage !== 5)}" @mouseover="indexHover = 5" @mouseout="indexHover = -1"></li>
      </ul>
    </div>
    <!-- 翻滚页面 -->
    <div class="login-slider" ref="sliderGroup">
      <!-- page 1 -->
      <div id="p0" class="index-u" :style="uImg(1)" :class="{'page-before': prevIndex === 1 ,'page-after': nextIndex === 1, 'page-current': 1 === currentPage}">
        <div class="index-u-item index-u0-item">
          <div class="logo-box">
            <img class="logo-img" src="~/assets/icon/logo@2x.png"/>
            精品洗涤缔造精致生活, 一心一意做洗涤
          </div>
        </div>
        <div class="index-mask" ></div>
        <!-- 登陆-component -->
        <login-component class="login-component"></login-component>
      </div>
      <!-- page 2 -->
      <div id="p1" class="index-u" :style="uImg(2)" :class="{'page-before': prevIndex === 2 ,'page-after': nextIndex === 2, 'page-current': 2 === currentPage}">
        <div class="index-u-item index-u2-item">
          <p class="p1">用数据洞察新零售密码</p>
          <p class="p2">致力于多场景下的数据化管理平台</p>
        </div>
        <div class="index-mask" ></div>
      </div>
      <!-- page 3 -->
      <div id="p2" class="index-u" :style="uImg(3)" :class="{'page-before': prevIndex === 3 ,'page-after': nextIndex === 3, 'page-current': 3 === currentPage}">
        <div class="index-u-item index-u4-item">
          <p class="t">我们能提供什么?</p>
          <div class="offer-w">
            <!-- 3 left -->
            <div class="offer-w1">
              <p class="title">全渠道的数据集成</p>
              <p class="sub-title">跨平台异构数据集成，提供数据分析基础</p>
              <div class="content">
                <p>
                  <span>CRM系统</span>
                  <span>至尊洗衣</span>
                  <span>月亮小屋</span>
                </p>
                <p>
                  <span>ORD系统</span>
                  <span>网络爬虫</span>
                  <span>SFA系统</span>
                </p>
                <p>
                  <span>SAP系统</span>
                  <span style="visibility:hidden;">SAF系统</span>
                  <span style="visibility:hidden;">SAF系统</span>
                </p>
              </div>
            </div>
            <!-- 3 right -->
            <div class="offer-w2">
              <div class="w2-div">
                <p class="title">便捷的数据获取工具</p>
                <p class="sub-title">集合多数据源，将隔离数据整合，一步到位提取分析依据</p>
              </div>
              <div class="w2-div">
                <p class="title">“人人都是数据分析师”</p>
                <p class="sub-title">提供新零售中的过程性数据，人人都可用数据驱动业务决策</p>
              </div>
            </div>
          </div>
        </div>
        <div class="index-mask" ></div>
      </div>
      <!-- page 4 -->
      <div id="p3" class="index-u" :style="uImg(4)" :class="{'page-before': prevIndex === 4 ,'page-after': nextIndex === 4, 'page-current': 4 === currentPage}">
        <div class="index-u-item index-u6-item">
          <p>核心应用</p>
          <div class="app-box">
            <div class="app-item" v-for="(item, index) in appData" :key="index" :class="{'bottom-border':index<6, 'right-border':index!==5&&index!==11}">
              <div style="position: relative; margin-bottom: 10px;">
                <img :src="item.img" />
              </div>
              {{item.name}}
            </div>
          </div>
        </div>
        <div class="index-mask"></div>
      </div>
      <!-- page 5 -->
      <div id="p4" class="index-u" :style="uImg(5)" :class="{'page-before': 5 < currentPage, 'page-after': 5 > currentPage, 'page-current': 5 === currentPage}">
        <div class="index-u-item index-u8-item">
          <p class="t2">你想了解更多吗?</p>
          <div class="offer-w">
            <!-- 5 left -->
            <div class="offer-w1">
              <div class="content2">
                <div class="item">
                  <img src="~/assets/icon/call@2x.png" class="call" />
                  <div class="flex-column-align">
                    <p>24小时消费者热线</p>
                    <p>400-111-1118</p>
                  </div>
                </div>
                <div class="item">
                  <img src="~/assets/icon/mail@2x.png" class="email" />
                  <div class="flex-column-align">
                    <p>客服邮箱</p>
                    <p>400@bluemoon.com.cn</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 5 right -->
            <div class="offer-w2">
              <div>
                <p class="title">微信公众号</p>
                <div class="wechat-code">
                  <div class="flex-column-center" style="margin-left: 25px">
                    <img src="https://domp.bluemoon.com.cn/images/common/login-yyxw-gzh.jpg" />
                    月亮小屋
                  </div>
                  <div class="flex-column-center" style="margin-left: 80px">
                    <img src="https://domp.bluemoon.com.cn/images/common/login-bluemoon-gzh.png" />
                    至尊洗衣
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p id="foot">Copyright 2019@ 蓝月亮（中国）有限公司、广州蓝月亮实业有限公司、蓝月亮（天津）有限公司 All Rights Reserved粤ICP备06004747号</p>
        </div>
        <div class="index-mask" ></div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {addClass, addEvent} from 'utils/util'
import LoginComponent from 'components/loginComponent'
import {down, downActive, u0, u2, u4, u6, u8, shejitupf, baobiaoAPP, jingzhunyinxiao, qitaicon} from '@/utils/imgUrl'
let preH = 0
export default {
  data () {
    return {
      currentPage: 1, // 当前页
      indexHover: -1, // 页码hover
      downActive, // down-active-icon
      down, // down-icon
      downImg: down, // downicon-default
      appData: [{
        id: 0,
        name: 'BMSpider',
        img: qitaicon
      }, {
        id: 1,
        name: 'BMBI',
        img: qitaicon
      }, {
        id: 2,
        name: '数据埋点',
        img: qitaicon
      }, {
        id: 3,
        name: '精准营销',
        img: jingzhunyinxiao
      }, {
        id: 4,
        name: '用户画像',
        img: qitaicon
      }, {
        id: 5,
        name: '预测模型',
        img: qitaicon
      }, {
        id: 6,
        name: '指数模型',
        img: qitaicon
      }, {
        id: 7,
        name: '报表APP',
        img: baobiaoAPP
      }, {
        id: 8,
        name: '舆情监控',
        img: qitaicon
      }, {
        id: 9,
        name: '作业监控',
        img: qitaicon
      }, {
        id: 10,
        name: '设计图评分',
        img: shejitupf
      }, {
        id: 11,
        name: 'BMJOBS',
        img: qitaicon
      }]
    }
  },
  methods: {
    /* ***
      切换fullpage的动画，timer控制速度
      currentPage：当前页，小于是上一页，大于是下一页
    *** */
    uImg (u) {
      let uImg
      switch (u) {
        case 1: uImg = u0; break
        case 2: uImg = u2; break
        case 3: uImg = u4; break
        case 4: uImg = u6; break
        case 5: uImg = u8; break
      }
      let percent = 100
      let time = 1
      if (u === this.currentPage) {
        percent = (u - 1) * (-100)
      } else if (u < this.currentPage) {
        time = 10000
        percent = u * (-100)
      } else if (u > this.currentPage) {
        time = 2
        percent = u * 100
      }
      return {
        background: `url('${uImg}') no-repeat center center`,
        backgroundSize: 'cover',
        transition: `transform ${time}s`,
        transform: `translateY(${percent}%)`
      }
    },
    // 切换fullpage
    goPage (page) {
      if (page) {
        this.currentPage = page
      } else if (Number(this.currentPage) + 1 <= 5) {
        this.currentPage = 1 + Number(this.currentPage)
      }
    },
    changePage (index, d) {
      this.currentPage = index
    }
  },
  computed: {
    nextIndex () {
      return this.currentPage + 1
    },
    prevIndex () {
      return this.currentPage - 1
    }
  },
  mounted () {
    let children = this.$refs.sliderGroup.children
    let _this = this
    let timer = null
    let start = 0
    // 滚轮处理
    function scrollHandler (direction) {
      // 防止重复触发滚动事件
      if (timer != null) {
        return
      }
      if (direction === 'down') {
        _this.currentPage !== 5 && _this.changePage(_this.nextIndex)
      } else {
        _this.currentPage !== 1 && _this.changePage(_this.prevIndex)
      }
      timer = setTimeout(function () {
        clearTimeout(timer)
        timer = null
      }, 1500)
    }
    // 监听滚轮事件
    if (navigator.userAgent.indexOf('Firefox') > -1) {
      addEvent(
        document.body,
        'DOMMouseScroll',
        function (event) {
          // Firefox
          let direction = event.detail > 0 ? 'up' : 'down'
          scrollHandler(direction)
        }
      )
    } else {
      addEvent(
        document.body,
        'mousewheel',
        function (event) {
          // IE/Opera/Chrome
          let direction = event.wheelDelta > 0 ? 'up' : 'down'
          scrollHandler(direction)
        }
      )
    }
  },
  components: {
    LoginComponent
  }
}
</script>
<style lang="less">
@import '~assets/style/variable.less';
@import '~assets/style/mixin.less';
.login-component {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 250px;
  height: 350px;
  z-index: 10000;
}
.login-page, .login-slider {
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: all 0.5s ease 0s;
  .slider-item {
    box-sizing: border-box;
    overflow: hidden;
  }
  .index-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    top:0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #213B60;
    opacity: 0.8;
  }
  .index-u {
    width: 100%;
    height: 100%;
    min-height: 590px;
    position: relative;
  }
  .down {
    width: 30px;
    height: 30px;
    position: absolute;
    bottom: 48px;
    left:50%;
    transform: translate(-50%, 0);
    z-index: 10;
  }
  // 右上角标
  .login-btn {
    position: fixed;
    right: 40px;
    top: 20px;
    display: flex;
    z-index:10000;
    .login-btn-box {
      .cursor-pointer;
      font-size: @font-size-medium-x;
      width: 98px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      border: 1px solid #fff;
      &:hover {
        border: 1px solid @color-theme;
        background: @color-theme;
      }
    }
  }
}
.page-index {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  .page-index-c {
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 5px;
    border: 1px solid #fff;
    margin-top: 12px;
  }
  .page-index-current {
    background: #fff;
    border: 1px solid #fff;
  }
  .page-index-hover {
    background: @color-theme;
    border: 1px solid @color-theme;
  }
}
/* 水平、垂直居中 */
.all-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.index-u-item {
  z-index: 3000;
  position: relative;
}
.index-u0-item {
  position: absolute;
  top: 20px;
  left: 40px;
  .logo-box {
    font-size: @font-size-medium;
    width: 400px;
    .logo-img {
      height: 40px;
      width: 108.6px;
      margin-right: 10px;
    }
  }
}
.index-u2-item {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  .p1 {
    font-size: 36px;
    margin-bottom: 20px;
    width: 400px;
  }
}
.index-u4-item, .index-u8-item {
  position: relative;
  width: 100%;
  height: 100%;
  .t {
    font-size: 36px;
    position: absolute;
    top: 150px;
    left: 180px;
    width: 320px;
  }
  .title {
    font-size: 24px;
    width: 336px;
  }
  .sub-title, .content {
    font-size: 16px;
    margin-top: 12px;
    line-height: 25px;
    width: 336px;
  }
  .offer-w {
    width: 1100px;
    position: absolute;
    display: flex;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);
    .offer-w1, .offer-w2{
      height: 206px;
      background: rgba(256,256,256, 0.1);
      padding: 30px 67px;
      width: 320px;
      width: 540px\9;
    }
    .offer-w2 {
      display: flex;
      flex-direction: column;
      margin-left: 150px;
      .w2-div {
        margin-bottom: 26px;
      }
    }
    .content {
      height: 120px;
      display: flex;
      flex-direction: column;
      margin-top: 18px;
      p {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
.index-u6-item {
  width:100%;
  height: 100%;
  position:relative;
  p {
    font-size: 36px;
    position: absolute;
    top: 120px;
    left: 100px;
    width: 300px;
  }
  .app-box {
    display: flex;
    flex-wrap: wrap;
    width: 1348px;
    position: absolute;
    align-items: center;
    bottom: 100px;
    left: 50%;
    transform: translate(-50%, 0);
    .app-item {
      width: 222.5px;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(256, 256, 256, 0.1);
      img {
        z-index: 100;
        width: 88px;
        height: 88px;
        margin: 4px;
      }
    }
  }
}
.index-u8-item {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .t2 {
    font-size: 36px;
    width: 300px;
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .content2 {
    display: flex;
    flex-direction: column;
    height: 200px;
  }
  .item {
    display: flex;
    line-height: 25px;
    margin-top: 25px;
    img {
      margin-right: 40px;
      width: 57px;
      height: 57px;
    }
  }
  .wechat-code {
    display: flex;
    margin-top: 30px;
    img {
      width: 100px;
      height: 100px;
      margin-bottom: 20px;
    }
  }
}
#foot {
  position: absolute;
  bottom: 30px;
  width: 1000px;
  text-align: center;
  font-size: @font-size-medium;
  left:50%;
  transform: translateX(-50%);
}
.bottom-border {
  border-bottom:1px solid #1B3151;
}
.right-border {
  border-right:1px solid #1B3151;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue